<template>
  <v-row class="align-center" dense>
    <v-col class="col-auto subheading">
      Download Status:
      {{ exportStatus }}
    </v-col>
    <v-col
      v-if="loading || fileGenerating"
      class="col-auto pl-2"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-col>
    <v-col
      v-if="fileError"
      class="col-auto"
    >
      <v-icon
        :color="disabled ? 'grey' : 'error'"
        class="pb-1"
      >
        error
      </v-icon>
    </v-col>
    <v-col
      v-if="fileReady"
      class="col-auto"
    >
      <v-icon
        :color="disabled ? 'grey' : 'success'"
        class="pb-1"
      >
        done
      </v-icon>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'TextingCancelStatus',
  props: {
    // Job States
    // NoJob = 0,
    // Created = 1,
    // Processing = 2,
    // Error = 3,
    // FileExists = 4
    value: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    notStarted () {
      return this.value === 0;
    },
    fileGenerating () {
      return (this.value === 1 || this.value === 2);
    },
    fileError () {
      return this.value === 3;
    },
    fileReady () {
      return this.value === 4;
    },
    exportStatus () {
      if (this.notStarted) {
        return 'Not Started';
      }
      if (this.fileGenerating) {
        return 'Preparing Data';
      }
      if (this.fileError) {
        return 'Error';
      }
      if (this.fileReady) {
        return 'Ready to Download';
      }
      return 'Unknown';
    }
  }
};
</script>
